import { Component } from '@angular/core';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.scss'],
  standalone: false // NOSONAR
})
export class UnauthorizedComponent {
  constructor(
  ) {}

  ngOnInit(): void { // NOSONAR
    console.info('')
  }
}